import React from "react";
import { Control, FieldValues } from "react-hook-form";
import {
  LocationContextProps,
  useLocationsContext,
} from "../../../context/LocationsContext";
import { useTranslation } from "react-i18next";
import { Select } from "@velocity-ehs/component-library";

type CountrySelectProps<TData extends FieldValues> = {
  control: Control<TData>;
  errors?: any;
  disabled: boolean;
  readOnly?: boolean;
};

const CountrySelect = <TData extends FieldValues>({
  control,
  errors,
  disabled,
  readOnly,
}: CountrySelectProps<TData>): React.ReactElement => {
  const locationsContext: LocationContextProps = useLocationsContext();
  const countries = locationsContext.countryList;
  const { t } = useTranslation();

  return (
    <Select
      control={control}
      name={"address.nation"}
      label={t("locations_Country")}
      options={countries}
      display="name"
      errorMessage={errors.address?.nation?.message}
      disabled={disabled}
      required
      readOnly={readOnly}
    />
  );
};

export default CountrySelect;
